import React from 'react';
import { connect } from 'react-redux';

class Pagination extends React.Component {
    constructor(props) {

        super(props);
    }

    componentDidMount() {
        jQuery('[data-toggle="tooltip"]').tooltip({
            html: true,
            container: 'body',
            boundary: 'window',
            delay: { show: 500, hide: 50 }
        });
    }
    render() {
        let nextDisabled = false;
        let prevDisabled = false;
        let firstNumber = ((this.props.increment * this.props.state.current_page) - this.props.increment);
        if (firstNumber < 1) {
            firstNumber = 1;
        }
        if (!this.props.state.initial_feedbacks.length) {
            firstNumber = 0;
        }
        let secondNumber = (this.props.increment * this.props.state.current_page);
        if (secondNumber < this.props.total) {
            secondNumber = this.props.increment * this.props.state.current_page;
        } else {
            secondNumber = this.props.total;
            nextDisabled = true;
        }

        if (this.props.state.current_page === 1) {
            prevDisabled = true;
        }
        return (
            <div className="d-flex flex-wrap align-items-center justify-content-center text-09em roboto">
                <span className={'text-center'}>{firstNumber} - {secondNumber} of {this.props.total}</span>
                <div className={'d-flex next-prev-wrapper'}>
                    <span
                        data-toggle="tooltip" data-placement="bottom"
                        data-title={__('Previous Page')}
                        onClick={!prevDisabled ? this.props.onPrevClick : () => { }} data-direction="prev" className={`left-carat ${prevDisabled ? '' : 'cursor-pointer'}`} style={{ opacity: prevDisabled ? 0.3 : 1 }}></span>
                    <span
                        data-toggle="tooltip" data-placement="bottom"
                        data-title={__('Next Page')}
                        onClick={!nextDisabled ? this.props.onNextClick : () => { }} data-direction="next" className={`right-carat ${nextDisabled ? '' : 'cursor-pointer'}`} style={{ opacity: nextDisabled ? 0.3 : 1 }}></span>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(Pagination);
